import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";
import Account from "@/helper/AccountHelper.js";

/**
 * @method apiGetTierLevel
 */
export default {
    apiGetTierLevel: function() {
        let token = Account.getToken();
        const param = {
            device_app_id: ConfigManager.getAppId(),
        };
        var url = ConfigManager.getApiModuleUrl() + `/profile/me/level`;
        return BzbsApi.connectBzbsGet(url, token, param).pipe(map(res => res.data));
    },
}
